import Tooltip from '@material-ui/core/Tooltip';
import React from 'react';
import { Img } from '~frontend-common/components/ui';
import { Button } from '~ui-kit/components/button/button';
import { css, styled } from '~ui-kit/styled-components';

interface NavbarButtonProps {
  id?: string;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  href?: string;
  icon?: React.ReactNode;
  iconSrc?: string;
  label?: string;
  tooltip?: string;
  disabled?: boolean;
}

export function NavbarButton({ icon, iconSrc, label, tooltip, onClick, href, disabled, ...props }: NavbarButtonProps) {
  const button = (
    <StyledButton
      appearance="none"
      shape="pill"
      href={href}
      onClick={onClick}
      $hasLabel={!!label}
      disabled={disabled}
      {...props}
    >
      {icon ? icon : iconSrc && <Img src={iconSrc} width="auto" height="100%" />}
      {label}
    </StyledButton>
  );

  if (tooltip) {
    return <Tooltip title={tooltip}>{button}</Tooltip>;
  }

  return button;
}

const StyledButton = styled(Button)<{ $hasLabel: boolean }>`
  && {
    min-width: unset;
    min-height: unset;
    padding: 8px ${(props) => (props.$hasLabel ? '12px' : '8px')};

    .MuiButton-label {
      text-transform: uppercase;
      font-weight: 600;

      > img {
        ${(props) =>
          props.$hasLabel &&
          css`
            margin-right: 8px;
          `}
      }
    }
  }
`;
